import api from './baseApi';
import { ImportedDesignIsReady } from './typings/designs';
import type { SignedUrlResponse } from '@/api/typings/image';

export const getRecentImportedDesigns = async (
    lastImportedDesignsIdCheck: string
): Promise<ImportedDesignIsReady[]> => {
    const url = `/MyDesigns/RecentImportedDesigns/${lastImportedDesignsIdCheck}`;
    const response = await api.get(url);
    return response.data;
};

export const getDesignImportSignedUrl = (): Promise<SignedUrlResponse> =>
    api.get<SignedUrlResponse>('MyDesigns/ImportSignedUrl').then(({ data }) => data);

export const importDesignZip = (filename: string): Promise<string> =>
    api.get<string>(`/MyDesigns/Import/${encodeURIComponent(filename)}`).then(({ data }) => data);
